import { ClipboardCopy, Typography } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import styles from "./GenericCell.module.css";

interface GenericCellProps {
  value: {
    content: string;
    subtext?: string;
    testId: string;
    onCopySubtext?: () => void;
    clipboardCopyLabel?: string;
    index?: number;
    hoveredRowIndex?: number;
    iconLeft?: React.ReactElement;
  };
}

const GenericCell: React.FC<GenericCellProps> = ({
  value: {
    content,
    subtext,
    onCopySubtext,
    testId,
    clipboardCopyLabel,
    index,
    hoveredRowIndex,
    iconLeft,
  },
}) => {
  return (
    <div className={styles.genericCell} data-testid={testId}>
      {iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
      <div>
        <Typography
          as="p"
          variant={subtext ? "heading_xs" : "body_sm"}
          className={classNames(styles.cellText, {
            [styles.cellHeading]: subtext,
            [styles.cellContent]: !subtext,
          })}
        >
          {content}
        </Typography>
        {subtext && (
          <Typography
            as="span"
            variant="body_sm"
            className={styles.cellContent}
          >
            {subtext}
            {onCopySubtext && (
              <ClipboardCopy
                className={styles.subtextCopy}
                label={clipboardCopyLabel}
                data-testid="copy-button"
                iconClassName={classNames(styles.copyButton, {
                  [styles.hover]: index === hoveredRowIndex,
                })}
                onCopy={onCopySubtext}
                noBackground
                text={subtext}
                color="interface"
              />
            )}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default GenericCell;
